import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WalkInBoard } from '../../shared/interfaces';
import { REQUIRE_AUTH } from '../../shared/interceptors/auth-context';
import { API_BASE_URL } from '../../shared/api/api.tokens';

/**
 * Turnos por orden de llegada. En la web solo se consultan: registrar, asignar
 * y terminar turnos se hace desde la app móvil.
 */
@Injectable({ providedIn: 'root' })
export class WalkInsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  /** GET /api/v1/walk-ins/board — the business comes from the token */
  getBoard(): Observable<WalkInBoard> {
    return this.http.get<WalkInBoard>(`${this.baseUrl}/api/v1/walk-ins/board`, {
      context: new HttpContext().set(REQUIRE_AUTH, true),
    });
  }
}
